import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="#FBE9B1"
      d="M27.088 19.075A11.489 11.489 0 0 1 12.925 4.912a11.5 11.5 0 1 0 14.163 14.163"
    />
    <path
      fill="#E2BA2B"
      d="M12.657 3.949A12.501 12.501 0 1 0 28.05 19.343a1 1 0 0 0-1.233-1.231 10.488 10.488 0 0 1-12.93-12.93 1 1 0 0 0-1.231-1.233m-1.061 2.515-.025.208a12.49 12.49 0 0 0 9.253 13.423l.403.098c1.348.305 2.734.384 4.101.236l.206-.026-.05.112a10.5 10.5 0 0 1-6.807 5.632 10.504 10.504 0 0 1-12.804-7.414 10.5 10.5 0 0 1 5.612-12.217z"
    />
  </svg>
);
const SvgIconWeatherMoon = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconWeatherMoon);
export default Memo;
